import { CardRadio } from '@/components/ui/CardRadio'
import { cn } from '@/lib/utils'
import type { FieldInputProps } from './fieldInputProps'

const SHORT_LABEL = 24

/** One of a few options as cards: side by side when they're short, stacked when any carries help or a long label. */
export function ChoiceField({ field, value, onChange, id, invalid, disabled }: FieldInputProps<string>) {
  const stacked = field.options.some((option) => option.help || option.label.length > SHORT_LABEL)

  return (
    <div
      id={id}
      role="radiogroup"
      aria-invalid={invalid || undefined}
      className={cn('gap-2', stacked ? 'flex flex-col' : 'flex flex-wrap')}
    >
      {field.options.map((option) => (
        <CardRadio
          key={option.value}
          className={cn(
            !stacked && 'min-w-28 flex-1',
            invalid && value !== option.value && 'border-destructive'
          )}
          isSelected={value === option.value}
          onSelect={() => onChange(option.value)}
          disabled={disabled}
        >
          <span className="block">{option.label}</span>
          {option.help && (
            <span className="text-muted-foreground block text-xs font-normal">{option.help}</span>
          )}
        </CardRadio>
      ))}
    </div>
  )
}
